import React from "react";

const C2BenefitsMain = () => {
  return (
    <div className="LvlBenefitsMainContainer">
      <ul>
        <li>
          <span>🗣️ Enhanced Communication Skills: </span>
          Increase your proficiency by conversing with native speakers, allowing
          you to discuss political and scientific research topics fluently.
        </li>
        <li>
          <span>📚 Advanced Understanding: </span> Comprehend conversations at
          any pace, even when spoken by native speakers. This level builds on
          everything from A1 to C1, ensuring a thorough understanding of the
          language.
        </li>
        <li>
          <span>📰 Comprehensive Comprehension: </span> Understand practically
          everything you read or hear without any problems. Summarize
          information from various sources and present justifications and
          explanations uniformly.
        </li>
        <li>
          <span>💬 Fluent and Precise Expression:</span>
          Express yourself promptly, fluently, and precisely, clarifying subtle
          nuances within complex topics.
        </li>
        <ul>
          <h3>Main Topics:</h3>
          <li>Communication and Media</li>
          <li>History and Memories</li>
          <li>Feelings, Lies, Strengths, and Weaknesses</li>
          <li>School Time</li>
          <li>Career Opportunities and Professions</li>
        </ul>
        <ul>
          <h3>Grammar Focus:</h3>
          <li>Tenses of the Verbs</li>
          <li>Verbs with Prefixes (Separable and Non-Separable)</li>
          <li>Subjunctive II</li>
          <li>Subjunctive I</li>
          <li>Adverbial Clauses</li>
          <li>Verbs and Their Complements</li>
          <li>Noun Connectors</li>
          <li>Word Formation of Nouns</li>
          <li>Participles as Adjectives</li>
          <li>Nominalized Adjectives and Participles</li>
          <li>Relative Clauses</li>
        </ul>
        <p>
          Join Prizma Academy’s C2 Level German Course in Bangalore to master
          the language and open doors to numerous opportunities in education and
          career!
        </p>
      </ul>
    </div>
  );
};

export default C2BenefitsMain;
